import consola from 'consola';

const Logger = consola.create({
  level: process.env.NODE_ENV === 'production' ? 1 : 4
});

export { Logger };
